import "./App.css";
import './toastify.css';
import { useEffect } from "react";
import styled from "styled-components";
import RoutesAuth from "./pages/RoutesAuth";
import RoutesAdmin from "./pages/RoutesAdmin";
import { RootState } from "./redux/rootReducers";
import parseBouncer from "./helpers/parseBouncer";
import { useDispatch, useSelector } from "react-redux";
import { getUserAsync, setLoading, updateToken } from "./redux/reducers/authorization/authorization.actions";
import { ToastContainer } from "react-toastify";

const App = () => {
  const dispatch = useDispatch();

  const authorizedUser = useSelector((state: RootState) => state.authorization.authorizedUser);

  useEffect(() => {
    const bouncer = parseBouncer();
    if (bouncer.token) {
      setTimeout(() => {
        dispatch(updateToken(bouncer.token));
        dispatch(getUserAsync.request({ token: bouncer.token }));
      }, 1000);
    } else {
      dispatch(setLoading(false));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root>
      <ToastContainer
        draggable
        rtl={false}
        closeOnClick
        pauseOnHover
        autoClose={3000}
        pauseOnFocusLoss
        newestOnTop={false}
        position="top-center"
        hideProgressBar={false}
      />
      {(() => {
        if (authorizedUser) {
          return <RoutesAdmin />;
        } else {
          return <RoutesAuth />;
        }
      })()}
    </Root>
  );
};

const Root = styled.div`
  background: var(--color-base);
  width: 100%;
  min-height: 100vh;
`;

export default App;
